import Util from '../../util/util';

export const NOVA_BANNER_DISMISSED_KEY = 'nova-entry-banner-dismissed';

/**
 * Whether this person has closed the Nova entry banner.
 *
 * Held in localStorage, which is per browser rather than per person: dismissing it on a laptop
 * leaves it showing on a second machine. The ticket asks for the dismissal to follow the person
 * across devices, and nothing in this product stores a per-person UI preference server-side yet -
 * there is no generic preference record to add a key to, so that would be a new field, mutation
 * and migration across two more services.
 *
 * This matches what the Sprints page already does for its own Nova column toggle, and is wrong
 * only in the one way noted above. A follow-up carries it to the account.
 *
 * Closed only for the exact stored value, so anything else - a value written by a future version,
 * or nothing at all from a browser with storage disabled - leaves the banner showing. Util's
 * storage helpers already swallow a browser refusing access.
 */
export function readBannerDismissed(): boolean {
	return Util.localStorageGetItem(NOVA_BANNER_DISMISSED_KEY) === 'true';
}

export function writeBannerDismissed(dismissed: boolean): void {
	Util.localStorageSetItem(NOVA_BANNER_DISMISSED_KEY, dismissed);
}
